import { useMemo } from 'react'
import { resolveError } from './resolveError'

export function useLookupFlow() {
  const value = useMemo(() => {
    /** */
    function getResolver<Page extends keyof typeof resolveError>(
      page: Page,
      api: keyof typeof resolveError[Page]
    ) {
      return resolveError[page][api]
    }

    return {
      getResolver,
    }
  }, [])
  return value
}
